import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:"合同"},
  getters: {
    getTitle (state) {
      return state.title;
    }
  },
  mutations: {
    setTitle (state,n) {
      state.title = n;
    }
  },
  actions: {
    increment (context,n) {
      context.commit('setShopId',n)
    }
  },
  modules: {
  }
})
